import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import UploadRepList from '../UploadRepList/UploadRepList';
import {
	setAlertActionCreator,
	rerenderCurrentDialogActionCreator
} from 'plugins/store/reducers/common.reducer';
import { isEqual } from 'lodash';

import { setNumberRowsPerPageActionCreator } from 'plugins/store/reducers/settings.reducer';
import { search as searchRepList, checkUniqNumber, checkIsValidNumber } from 'services/rep-list.service';
import { withSnackbar } from 'notistack';
import withForm from 'hoc/withForm';
import { updateContactCenter } from 'services/contact-center.service';
import AddPhoneNumberIcon from 'assets/img/add-phone-number.svg';
import CustomPhoneLabel from 'components/CustomPhoneLabel/CustomPhoneLabel';
import AddNewNumberForm from 'components/SpoofPreventionList/AddNewNumberForm';
import ReactTable from 'components/ReactTable/ReactTable';
import DuplicatesTemplate from 'components/SpoofPreventionList/DuplicatesTemplate';
import { withStyles } from '@material-ui/core/styles';
import SnackMessage from 'components/Snackbar/SnackMessage';
import { mapRepListResult } from 'mappings/repListMappings';
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import { mapRepListToServiceModel } from 'mappings/repListMappings';
import Tooltip from '@material-ui/core/Tooltip';

const styles = {
	spoofPreventionListWrapper: {
		padding: '0.9375rem 20px',
	},
	addRecord: {
		marginTop: '4px',
		padding: '12px 0 12px 12px',
		'&:hover,&:focus': {
			filter: 'invert(1)',
		},
	},
	actionIcon: {
		height: '18px',
		'&:hover,&:focus': {
			filter: 'invert(.6)',
		},
		cursor: 'pointer',
	},
	right: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	uploadRepListButton: {
		marginLeft: 20,
		display: 'flex',
	},
};

class SpoofPreventionList extends Component {
	state = {
		parentContactCenter: undefined,
		data: [],
		totalRecordsCount: 0,
		pageCount: 0,
		tableFilterQuery: '',
		tablePageIndex: 0,
		tablePageSize: 10,
		loading: false,
		currentPhoneNumber: null,
		currentPhoneId: null,
		phoneNumberValid: true,
	};

	columns = [
		{
			Header: 'Phone Number',
			accessor: 'phoneNumber',
			disableFilters: true,
			disableSortBy: false,
			Cell: ({ row }) => {
				return (
					<CustomPhoneLabel
						value={row.cells[0]?.value}
					/>
				)
			},
		},
		{
			Header: 'Actions',
			accessor: 'actions',
			className: 'flag-align-right',
			disableFilters: true,
			disableSortBy: true,
			Cell: ({ data, row }) => {
				return (
					<div>
						<Edit
							className={this.props.classes.actionIcon}
							onClick={() => this.onEditClick(data[row.id])}
						/>
						<Delete
							className={this.props.classes.actionIcon}
							onClick={() => this.onDeleteClick(data[row.id])}
						/>
					</div>)
			},

		},
	];


	componentDidMount() {
		/* eslint-disable */
		const {
			data,
			parentContactCenter: {
				verifiedImage,
				fraudImage,
				...parentContactCenter
			} = {},
		} = this.props;
		/* eslint-enable */

		this.setState({
			data,
			parentContactCenter,
		});
	}

	componentDidUpdate(prevProps, prevState) {
		/* eslint-disable */
		const {
			parentContactCenter: {
				verifiedImage,
				fraudImage,
				...parentContactCenter
			} = {},
		} = this.props;
		/* eslint-enable */
		if (!isEqual(prevState.parentContactCenter, parentContactCenter)) {
			this.setState({
				parentContactCenter,
			});
		}
	}

	addPhoneNumber = async () => {
		if (!this.validatePhoneNumber()) {
			return;
		}

		const updatedPhonesList = [
			...this.state?.data,
			{
				phoneNumber: this.state.currentPhoneNumber,
				tempId: this.state?.data?.length,
			}
		];

		this.savePhoneNumbers(mapRepListToServiceModel(updatedPhonesList));
	}

	onEditClick(model) {
		this.setState({
			currentPhoneId: model?.id,
		});
		this.syncCurrentPhoneNumber(model?.phoneNumber, () => this.showPhoneNumberPopup((phoneNumber) => this.editPhoneNumber(model, phoneNumber)));
	}

	editPhoneNumber = async (model, phoneNumber) => {
		if (!this.validatePhoneNumber()) {
			return;
		}

		const updatedPhonesList = this.state?.data.map(item => {
			const matched = item?.id ? item?.id === model?.id : item?.tempId === model?.tempId;

			if (matched) {
				item.phoneNumber = phoneNumber;
			}

			return item;
		});

		this.savePhoneNumbers(mapRepListToServiceModel(updatedPhonesList));
	}

	onDeleteClick(model) {
		const { setAlert } = this.props;
		const listToDelete = mapRepListToServiceModel(this.state?.data.filter((phone) =>
			phone?.id
				? phone?.id === model?.id
				: phone?.tempId === model?.tempId
		));
		const listToUpdate = mapRepListToServiceModel(this.state?.data.filter((phone) =>
			phone?.id
				? phone?.id !== model?.id
				: phone?.tempId !== model?.tempId
		));

		const deletePhoneNumber = {
			type: 'warning',
			title: 'Are you sure you want to remove this number?',
			confirmBtnText: 'Ok',
			onConfirm: async () => {
				setAlert(null);
				this.savePhoneNumbers(listToUpdate, listToDelete);
			},
			onCancel: () => {
				setAlert(null);
			},
		};
		setAlert(deletePhoneNumber);
	}

	syncCurrentPhoneNumber = (newVal, cb = () => { }) => {
		const isValid = this.validatePhoneNumber(newVal);

		this.setState({
			currentPhoneNumber: newVal,
			phoneNumberValid: isValid,
		}, cb);
	};

	validatePhoneNumber = (newVal = this.state.currentPhoneNumber) => {
		const isValid = (newVal?.length >= 11 && newVal?.length <= 14);
		if (this.state.phoneNumberValid !== isValid) {
			this.setState({
				phoneNumberValid: isValid,
			});
		}
		return isValid;
	}

	savePhoneNumbers = async (updatedPhonesList, listToDelete = []) => {
		const { onPhoneNumbersListChange } = this.props;

		this.setState({
			data: updatedPhonesList,
			totalRecordsCount: updatedPhonesList?.length,
			pageCount: Math.ceil(updatedPhonesList.length / 10),
		});

		if (this.state.parentContactCenter?._id) {
			await this.savePhoneNumberDefault(updatedPhonesList, listToDelete);
		}
		if (onPhoneNumbersListChange) {
			onPhoneNumbersListChange(updatedPhonesList);
		}
	}

	savePhoneNumberDefault = async (updatedPhonesList, listToDelete = []) => {
		const { enqueueSnackbar } = this.props;

		try {
			this.setState({ loading: true });

			const model = {
				...this.state.parentContactCenter,
				callCenterId: this.state.parentContactCenter._id,
				orList: updatedPhonesList,
				deleteList: listToDelete,
				isFraudLogoChanged: false,
				isVerifiedLogoChanged: false,
			}

			const { duplicatedRepList } = await updateContactCenter(model);

			await this.fetchData({
				filterQuery: this.state.tableFilterQuery,
				pageIndex: this.state.tablePageIndex,
				pageSize: this.state.tablePageSize,
			});

			if (duplicatedRepList?.total > 0) {
				this.openResponseDialog({ ...duplicatedRepList });
			} else {
				enqueueSnackbar('Changes have been saved successfully', {
					content: (key, message) => <SnackMessage id={key} message={message} color='success' />,
				})
			}
		} catch (e) {
			enqueueSnackbar(e.resolvedErrorMessage, {
				content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
			})
		}

		this.setState({
			loading: false,
		});
	};

	openResponseDialog = (props) => {
		this.props.setAlert({
			type: 'scrollable',
			maxWidth: 'xs',
			children: <DuplicatesTemplate {...props} />,
			onConfirm: () => this.props.setAlert(null),
		});
	}

	showPhoneNumberPopup(onConfirmHandler) {
		const { setAlert, enqueueSnackbar } = this.props;

		setAlert({
			type: 'withForm',
			title: `${this.state.currentPhoneNumber ? 'Edit' : 'Add New'} Phone Number`,
			confirmBtnText: 'Save',
			disabled: false,
			children: (
				<AddNewNumberForm
					currentPhoneNumber={(() => this.state.currentPhoneNumber)()}
					handleOnChange={(value) => {
						this.syncCurrentPhoneNumber(value.replace(/\D/g, ""));
					}}
					isValid={(value) => this.validatePhoneNumber(value)}
				/>
			),
			onConfirm: async () => {
				let isValid;
				try {
					isValid = await checkIsValidNumber(this.state.currentPhoneNumber);
					const isDuplicate = await this.checkUniqNumberInList();

					if (!isDuplicate) {
						onConfirmHandler ? await onConfirmHandler(this.state.currentPhoneNumber) : await this.addPhoneNumber();

						if (this.state.phoneNumberValid) {
							setAlert(null);
							this.setState({
								currentPhoneNumber: null,
								currentPhoneId: null,
							});
						}
					}
				} catch (error) {
					setAlert(null);
					this.setState({
						currentPhoneNumber: null,
						currentPhoneId: null,
					});
					if (!isValid) {
						enqueueSnackbar(
							error.resolvedErrorMessage,
							{
								content: (key, message) => <SnackMessage id={key} message={message} color='danger' />,
							},
						);
					}
				}
			},
			onCancel: () => {
				this.setState({
					currentPhoneNumber: null,
					currentPhoneId: null,
				});
				setAlert(null);
			},
		});
	}

	checkUniqNumberInList = async () => {
		const { setAlert } = this.props;
		let isDuplicate = false;
		let duplicates = [];

		let isInCurrentCallCenter = this.state.data.some((element) =>
			element.phoneNumber === this.state.currentPhoneNumber
		);

		if (!isInCurrentCallCenter) {
			const response =
				await checkUniqNumber(this.state.parentContactCenter._id, this.state.currentPhoneNumber, this.state.currentPhoneId);
			isDuplicate = response.isDuplicate;
			duplicates = response.duplicates;
			isInCurrentCallCenter = response.isInCurrentCallCenter;
		}

		if (isInCurrentCallCenter || isDuplicate) {
			setAlert(null);
			this.openResponseDialog({ duplicates, isInCurrentCallCenter });
			this.setState({
				currentPhoneNumber: null,
				currentPhoneId: null,
			});
		}
		return isInCurrentCallCenter || isDuplicate;
	};

	onUploadedFromCsv = () => {
		this.fetchData();
		if (this.props.onPhoneNumbersListChange) {
			this.props.onPhoneNumbersListChange();
		}
	}

	render() {
		const { classes, isFrontEndData, rowsPerPage, setRowsPerPage } = this.props;
		const {
			data,
			tableFilterQuery,
			tablePageIndex,
			tablePageSize,
		} = this.state;
		this.fetchData = async ({
			filterQuery = tableFilterQuery,
			pageIndex = tablePageIndex,
			pageSize = tablePageSize,
		} = {}) => {
			if (!this.state.parentContactCenter?._id) {
				return;
			}

			this.setState({
				tableFilterQuery: filterQuery,
				tablePageIndex: pageIndex,
				tablePageSize: pageSize,
				loading: true,
			});

			const mappedResult = mapRepListResult(await searchRepList({
				pagination: {
					page: pageIndex,
					count: pageSize
				},
				filter: {
					phoneNumber: filterQuery,
					callCenterId: this.state.parentContactCenter._id,
				}
			}));

			this.setState({
				data: mappedResult.data,
				totalRecordsCount: mappedResult.total,
				pageCount: Math.ceil(mappedResult.total / pageSize),
				loading: false,
			});
			setRowsPerPage({
				table: 'spoofPreventionList',
				rowsPerPage: pageSize
			});
		};

		return (
			<div className={classes.spoofPreventionListWrapper}>
				<ReactTable
					title={{
						text: this.props.title,
						withCardIcon: false,
					}}
					isFrontEndData={isFrontEndData}
					clickableRows={false}
					rowsWithSelection={false}
					columns={this.columns}
					data={data}
					fetchData={this.fetchData}
					rowsPerPage={rowsPerPage}
					loading={this.state.loading}
					pageCount={this.state.pageCount}
					totalRecordsCount={this.state.totalRecordsCount}
					isPageRootComponent={false}
					addRecordComponent={
						<div className={classes.right}>
							<Tooltip
								arrow
								title="Add Number to the List"
							>
								<img
									src={AddPhoneNumberIcon}
									alt="add contact center button"
									className={classes.addRecord}
									onClick={() => {
										this.showPhoneNumberPopup();
									}}
								/>
							</Tooltip>
							{
								!this.props.callCenterCreation && (
									<div className={classes.uploadRepListButton}><UploadRepList
										className={classes.uploadRepListButton}
										callCenterId={this.state.parentContactCenter?._id}
										onUploaded={this.onUploadedFromCsv}
									/></div>
								)
							}
						</div>
					}
					allowDeleteAll
					onDelete={() => { }}
				></ReactTable>
			</div>
		);
	}
}

SpoofPreventionList.defaultProps = {
	title: 'Spoof Prevention List',
};

SpoofPreventionList.propTypes = {
	title: PropTypes.string,
	classes: PropTypes.any,
	setAlert: PropTypes.func,
	rerenderCurrentDialog: PropTypes.func,
	parentContactCenter: PropTypes.object,
	data: PropTypes.array,
	onPhoneNumbersListChange: PropTypes.func,
};

const mapStateToProps = (state) => {
	return {
		rowsPerPage: state.settings.rowsPerPage.spoofPreventionList,
	};
};

const mapDispatchToProps = (dispatch) => ({
	setAlert: bindActionCreators(setAlertActionCreator, dispatch),
	rerenderCurrentDialog: bindActionCreators(
		rerenderCurrentDialogActionCreator,
		dispatch
	),
	setRowsPerPage: bindActionCreators(
		setNumberRowsPerPageActionCreator,
		dispatch
	),
});

export default compose(
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps),
	withSnackbar,
	withForm,
)(SpoofPreventionList);

